import { render, staticRenderFns } from "./MemberDetailOnlyNickLayout.vue?vue&type=template&id=6191d4d6&scoped=true&"
import script from "./MemberDetailOnlyNickLayout.vue?vue&type=script&lang=js&"
export * from "./MemberDetailOnlyNickLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6191d4d6",
  null
  
)

export default component.exports